import { Controller, useFormContext } from 'react-hook-form'
import styled from 'styled-components'

import Check from '~/shared/assets/icons/Check'
import theme from '~/shared/styles/theme'

type Props = React.InputHTMLAttributes<HTMLInputElement> & {
  name: string
  options: { label: string; value: string }
}

export default function RHFCheckBox({ name, options }: Props) {
  const { control } = useFormContext()

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        const isChecked = field.value === options.value
        const handleToggle = () => {
          field.onChange(isChecked ? '' : options.value)
        }

        return (
          <Wrapper>
            <CheckboxWrapper $isChecked={isChecked} onClick={handleToggle}>
              {isChecked && (
                <Check color={theme.colors.white} width={21} height={21} />
              )}
              {options.label}
            </CheckboxWrapper>
          </Wrapper>
        )
      }}
    />
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  @media ${theme.device.medium} {
    align-items: start;
  }
`

const CheckboxWrapper = styled.div<{ $isChecked: boolean }>`
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;

  box-sizing: border-box;
  width: fit-content;
  min-width: 115px;
  height: 49px;
  padding: 20px 12px;

  font-size: 18px;
  font-weight: 500;
  line-height: 25px;
  color: ${({ $isChecked }) => ($isChecked ? theme.colors.white : '#313634')};

  background-color: ${({ $isChecked }) =>
    $isChecked ? theme.colors.mint_3 : 'transparent'};
  border: ${({ $isChecked }) => ($isChecked ? 'none' : '1px solid #c1c3c2')};
  border-radius: 12px;

  @media ${theme.device.medium} {
    justify-content: start;
    width: 100%;
    padding: 16px 12px;
  }
`
